export const topNavigation: Array<{
  name: string
  href: string
  current: boolean
  pages: null | Array<{ name: string; href: string }>
}> = [
  {
    name: 'Visiting',
    href: '/visiting',
    current: false,
    pages: null,
  },
  {
    name: 'Careers',
    href: '/careers',
    current: false,
    pages: null,
  },
]

export const bottomNavigation: Array<{
  name: string
  href: string
  current: boolean
  pages: null | Array<{ name: string; href: string }>
}> = [
  {
    name: 'Home',
    href: '/',
    current: false,
    pages: null,
  },
  {
    name: 'Visiting',
    href: '/visiting',
    current: false,
    pages: null,
  },
  {
    name: 'Careers',
    href: '/careers',
    current: false,
    pages: null,
  },
  {
    name: 'About',
    href: '/about',
    current: false,
    pages: null,
  },
  {
    name: 'Contact',
    href: '/contact',
    current: false,
    pages: null,
  },
]

export const productMenu: Array<{
  name: string
  href: string
  target: string
  current: boolean
  pages: null | Array<{ name: string; href: string }>
}> = [
  {
    name: 'Auto & Home',
    href: 'https://www.cerakoteceramics.com/',
    target: '_blank',
    current: false,
    pages: null,
  },
  {
    name: 'Cerakote',
    href: 'https://www.cerakote.com/',
    target: '_blank',
    current: false,
    pages: null,
  },
  {
    name: 'Prismatic Powders',
    href: 'https://www.prismaticpowders.com/',
    target: '_blank',
    current: false,
    pages: null,
  },
]
